import { PRIORITY_LEVELS } from '../components/LeadCard/types';

export const getPriority = (item) => {
  if (item.additional_data && item.additional_data.priority) {
    return item.additional_data.priority.toLowerCase();
  }
  return null;
};

export const getPriorityColor = (priority) => {
  const colors = {
    [PRIORITY_LEVELS.HIGH]: '#ff4d4f',
    [PRIORITY_LEVELS.NORMAL]: '#1890ff',
    [PRIORITY_LEVELS.LOW]: '#52c41a',
  };
  return colors[priority] || colors[PRIORITY_LEVELS.NORMAL];
};

export const getPriorityLabel = (priority) => {
  const labels = {
    [PRIORITY_LEVELS.HIGH]: 'Alta',
    [PRIORITY_LEVELS.NORMAL]: 'Normal',
    [PRIORITY_LEVELS.LOW]: 'Baixa',
  };
  return labels[priority] || labels[PRIORITY_LEVELS.NORMAL];
};